const EVENT_NAMES = {
	ONBOARDING_FORM_VISIT: "onboarding_form_visit",
	ONBOARDING_FORM_SUBMITTED: "onboarding_form_submitted",
	KYC_INITIATED: "kyc_initiated",
	RECHARGE_PAYMENT_INITIATED: "recharge_payment_initiated",
	RECHARGE_PAYMENT_DONE: "recharge_payment_done",
	RECHARGE_PAYMENT_FAILED: "recharge_payment_failed",
	SHIPPING_RATE_CALCULATOR_VISIT: "shipping_rate_calculator_visit",
	ADD_ORDER_CLICKED: "add_order_clicked",
	ORDER_PAYMENT_MODE_SELECTED: "order_payment_mode_selected",
	ORDER_ADDED_SUCCESS: "order_added_success",
	SHIP_NOW_INITIATED: "ship_now_initiated",
	BANNERS_CLICKED: "banners_clicked",
	RECHARGE_POPUP_VIEWED: "recharge_popup_viewed",
	RECHARGE_COUPON_ENTERED: "recharge_coupon_entered",
	RECHARGE_COUPON_FAILED: "recharge_coupon_failed",
	DASHBOARD_PAGE_VISIT: "dashboard_page_visit",
	SHIP_NOW_SUCCESS: "ship_now_success",
	LOW_BALANCE_NUDGED: "low_balance_nudged",
	SIDE_NAVIGATION_CLICKED: "side_navigation_clicked",
	BUTTON_CLICKED: "button_clicked",
};

export default EVENT_NAMES;
